module.exports = __webpack_public_path__ + "media/media/social/twitter-logo-silhouette-9936d4beddc0e8d1b8efdb26066423a5.png";